@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.users-description {
  color: var(--default--text-color--6);
}

.edit-user-banner {
  width: fit-content;

  > * button {
    font-size: 12px;
  }
}

.user-interaction-label {
  margin-top: @space-12;
  margin-bottom: @space-8;
  margin-right: @space-48;
}

.user-count {
  margin-top: @space-8;
}

.user-spinner {
  width: 56px;
}
